module.exports = __webpack_public_path__ + "static/media/clouds.ddc23917.png";


//////////////////
// WEBPACK FOOTER
// ./src/game/static/backgrounds/clouds.png
// module id = 238
// module chunks = 0